// ------------------------------------------------------------
// スタイルの transform を設定する関数
// http://hakuhin.jp/js/css_transform.html
// ------------------------------------------------------------
/*
var set_transform = require('./caracol/effect/set_transform.js');
var style = $('.target').get(0).style;
set_transform.caracolSetTransform( style, 'scale(.8)' );
*/


exports.set_transform = function( style, value ){
	var list = [
		"transform",
		"webkitTransform",
		"MozTransform",
		"msTransform",
		"OTransform"
	];
	var i;
	var num = list.length;
	for(i=0;i < num;i++){
		if(style[list[i]] !== undefined){
			style[list[i]] = value;
			return true;
		}
	}
	return false;
}


/*****************
 ** WEBPACK FOOTER
 ** /Users/dada/www/_template/.src/js/caracol2.0.0/effect/transform_css.js
 ** module id = 14
 ** module chunks = 0
 **/